import {remote} from '../constants/environment';
import {IInvoiceRequest} from '../interfaces/dtos/invoice-request.interface';

import {IStandardServiceResponse} from '../interfaces/services/standard-service.interface';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

const handleResponse = async (response: Response) => {
  if (response.status === 200) {
    const data = await response.json();

    if (data.success && data.payload) {
      return {
        success: true,
        payload: {},
      };
    } else {
      return {
        success: false,
        payload: {},
      };
    }
  }
};

export const postInvoiceRequest = async (
  request: IInvoiceRequest,
  token: string,
): Promise<IStandardServiceResponse> => {
  const remoteURI = remote.getSalesmanInvoicesUri();

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'POST',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
        body: JSON.stringify({
          payload: request,
        }),
      });
    },
    handleResponse,
    remoteURI,
  )) as IStandardServiceResponse;
};
